import { faViber, faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconButton, Menu, MenuItem } from "@mui/material";
import { Box } from "@mui/system";
import { ArrowDropDownIcon } from "@mui/x-date-pickers";
import PropTypes from "prop-types";
import { useState } from "react";
import PhoneIcon from "@mui/icons-material/Phone";

const PhoneNumberWithMenu = ({ phone = null }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleWhatsApp = () => {
    window.location.href = `whatsapp://send?phone=${phone}`;
    handleClose();
  };

  const handleViber = () => {
    window.open(`viber://chat?number=${phone}`, "_blank", "noopener,noreferrer");
    handleClose();
  };

  const handleCall = () => {
    window.location.href = `tel:${phone}`;
    handleClose();
  };

  if (!phone) return "-";

  return (
    <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "4px" }}>
      <span>{phone}</span>
      <IconButton
        size="small"
        onClick={handleClick}
        sx={{
          padding: "2px",
          "&:hover": {
            backgroundColor: "rgba(0, 0, 0, 0.04)",
          },
        }}>
        <ArrowDropDownIcon fontSize="small" />
      </IconButton>
      <Menu anchorEl={anchorEl} open={open} onClose={handleClose} onClick={(e) => e.stopPropagation()}>
        <MenuItem onClick={handleWhatsApp}>
          <FontAwesomeIcon icon={faWhatsapp} style={{ marginRight: "8px" }} />
          WhatsApp
        </MenuItem>
        <MenuItem onClick={handleViber}>
          <FontAwesomeIcon icon={faViber} style={{ marginRight: "8px" }} />
          Viber
        </MenuItem>
        <MenuItem onClick={handleCall}>
          <PhoneIcon fontSize="small" sx={{ mr: 1 }} />
          Call
        </MenuItem>
      </Menu>
    </Box>
  );
};

PhoneNumberWithMenu.propTypes = {
  phone: PropTypes.string,
};

PhoneNumberWithMenu.defaultProps = {
  phone: null,
};

export default PhoneNumberWithMenu;
